@if (true) {
<div [ngClass]="component.background_color || 'bg-col-51'">
    <div class="wrap flex-x flex-l p-t-4-s p-t-4-m p-b-4-s p-b-4-m p-t-16 p-b-16 p-r-0-s p-r-0-m p-r-0-l p-r-0-x">
        <!-- text -->
        <div class="w-3 w-12-m w-12-s left flex-column p-t-16-l p-t-16-x">
            <span class="p-b-1 o1 col-11"
                  *iCms="'subtitle' of component">
            </span>
            <span class="p-b-2 h2 col-1"
                  *iCms="'title' of component">
            </span>
            <span class="w-11 p-b-2 p1 text"
                  *iCms="'copy' of component; content: 'html'; skipEmpty: true">
            </span>
            @if (component?.cta_copy) {
            <span class="p-b-6 left">
                <href class="button-inline"
                      [link]="component.cta_link"
                      *iCms="'cta_copy' of component">
            </href>
            </span>
            }
        </div>
        <!-- slides -->
        <div class="w-9 w-12-m w-12-s">
            <carousel [slidesPerView]="[1.5, 3.15, 3.5, 3.5][client.sizeId]"
                      [navigation]="false"
                      [spaceBetween]="20"
                      [scrollbar]="false"
                      [pagination]="false"
                      [navigation]="{
                        nextEl: '.carousel-next-' + uid,
                        prevEl: '.carousel-prev-' + uid
                        }"
                      imageViewRoot>
                @for (item of component.elements; track item) {
                <ng-template swiperSlide>
                    <href [link]="item.image_link">
                        <div class="ratio-1-1 overflow-hidden flex flex-justify-center flex-middle m-b-2">
                            <local-shell />
                            <img class="rf b-radius-max"
                                 [image]="item.image" />
                        </div>
                    </href>

                    <div class="col-12 p2 center"
                         *iCms="'username' of item"></div>
                </ng-template>
                }
                <!-- navigation arrows -->
                <div slot="container-start">
                    <button class="pos-absolute top-50 left-4 z-5 _arrow"
                            [ngClass]="'carousel-prev-' + uid"
                            type="button"
                            aria-label="Previous slide">
                        <i class="icon-chevron-left"
                           aria-hidden="true"></i>
                    </button>
                    <button class="pos-absolute top-50 right-4 z-5 _arrow"
                            [ngClass]="'carousel-next-' + uid"
                            type="button"
                            aria-label="Next slide">
                        <i class="icon-chevron-right"
                           aria-hidden="true"></i>
                    </button>
                </div>
            </carousel>
        </div>
    </div>
</div>
}
